import styled from "styled-components";

export const Container = styled.div(() => ({
  display: "flex",
  backgroundColor: "#005CA9",
  width: "140px",
  margin: "auto",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "18px",
  cursor: "pointer",
  svg: {
    width: "20px",
    fill: "white",
    marginLeft: "8px",
  },
}));

export const Button = styled.button(() => ({
  display: "flex",
  width: "140px",
  height: "30px",
  justifyContent: "center",
  alignItems: "center",
  border: "none",
  backgroundColor: "#005CA9",
  color: "white",
  fontSize: "medium",
  fontWeight: 700,
  cursor: "pointer",
}));
